import { useState, useEffect } from 'react';
import axios from '../utils/axios';
import { FiGift } from 'react-icons/fi';

const GiftGuide = () => {
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchContent = async () => {
            try {
                const response = await axios.get('/settings');
                const data = response.data.data;
                setContent(data.giftGuide || '');
            } catch (error) {
                console.error('İçerik yüklenemedi:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchContent();
    }, []);

    if (loading) {
        return (
            <div className="min-h-[60vh] flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
            </div>
        );
    }

    return (
        <div className="max-w-4xl mx-auto px-4 py-8 md:py-12">
            <div className="text-center mb-10">
                <h1 className="text-3xl md:text-4xl font-serif text-gray-900 mb-4 flex items-center justify-center gap-3">
                    <FiGift className="text-primary-600" />
                    Hediye Rehberi
                </h1>
                <div className="h-1 w-20 bg-primary-600 mx-auto"></div>
            </div>

            <div
                className="prose prose-lg max-w-none prose-headings:font-serif prose-a:text-primary-600 hover:prose-a:text-primary-700"
                dangerouslySetInnerHTML={{ __html: content || '<p class="text-center text-gray-500">İçerik hazırlanıyor...</p>' }}
            />
        </div>
    );
};

export default GiftGuide;
